import React from "react";
import { colors } from "~/utils/colors";
import { breakPoints } from "~/utils/variables";
import { TagList } from "~/molecules/TagList";

interface Props {
  categoryName?: string;
  title: string;
  tags?: ReadonlyArray<{ readonly name?: string | null; readonly slug?: string | null } | null | undefined> | null;
}

export const DownloadArticleHeader: React.FC<Props> = ({ categoryName, title, tags }) => {
  return (
    <>
      <style jsx>{`
        .articleHeader {
          box-sizing: border-box;
          padding: 0 0 24px;
          width: 100%;
        }
        .badges {
          align-items: center;
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
          margin: 0;
        }
        .category {
          background: transparent;
          border: 1px solid ${colors.orange};
          border-radius: 30px;
          color: ${colors.orange};
          display: inline-block;
          font-size: 12px;
          font-weight: 700;
          line-height: 1;
          padding: 8px 12px;
        }
        .title {
          color: ${colors.defaultText};
          font-weight: 700;
          line-height: 1.35;
          margin: 16px 0 0;
        }
        .tagsWrap {
          margin: 12px 0 0;
        }
        @media (${breakPoints.sp}) {
          .articleHeader {
            padding: 0 0 20px;
          }
          .title {
            font-size: 20px;
          }
        }
        @media (${breakPoints.minPc}) {
          .title {
            font-size: 26px;
          }
        }
      `}</style>
      <header className="articleHeader">
        {categoryName && (
          <div className="badges">
            <span className="category">{categoryName}</span>
          </div>
        )}
        <h1 className="title">{title}</h1>
        {tags && tags.length > 0 && (
          <div className="tagsWrap">
            <TagList tags={tags} />
          </div>
        )}
      </header>
    </>
  );
};
